import { render } from "./instructionspageeditor.vue?vue&type=template&id=12536de9"
import script from "./instructionspageeditor.vue?vue&type=script&lang=js"
export * from "./instructionspageeditor.vue?vue&type=script&lang=js"

import "./instructionspageeditor.vue?vue&type=style&index=0&id=12536de9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__